// extracted by mini-css-extract-plugin
export default {"modal":"styles_modal__MOyHY","create-modal":"styles_create-modal__8-G8C"};